export default "__VITE_ASSET__ZiCccicE__"